module.exports = __webpack_public_path__ + "static/media/user_input_3.9ac9b91b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindRose/user_input_3.png
// module id = 2501
// module chunks = 0